module.exports = __webpack_public_path__ + "img/93.6c414983.jpg";